export default "__VITE_ASSET__hvqBju2U__"